"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastActionWidget = void 0;
/*
 * Copyright Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
/**
 * Review-summary label for how a geography point was set.
 * @param lastAction - Geography `properties.lastAction`
 */
const LastActionWidget = ({ lastAction }) => {
    const { t } = (0, react_i18next_1.useTranslation)(['admin']);
    if (!lastAction) {
        return null;
    }
    // Stored value stays `copy`; the admin label names the usual-place clone.
    const displayAction = lastAction === 'copy' ? 'clonedFromUsualPlace' : lastAction;
    return (react_1.default.createElement("span", { className: "_widget" },
        t('interviewStats.labels.lastAction'),
        ":",
        ' ',
        react_1.default.createElement("span", { className: "_strong" }, t(`interviewStats.labels.lastActionValues.${displayAction}`, displayAction))));
};
exports.LastActionWidget = LastActionWidget;
//# sourceMappingURL=LastActionWidget.js.map